import {
  UPDATE_SUGG_ARTICLES,
  UPDATE_SUGG_ARTICLE_TYPE,
  UPDATE_RECOMMENDED_LINKS_ADP_DATA,
  RESET_ANALYTICS_STATES,
} from '../actions/types';

const initialState = {
  suggestedArticles: [],
  suggestedArticleType: '',
  recommendedLinksAdpData: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SUGG_ARTICLES:
      return {
        ...state,
        suggestedArticles: action.payload,
      };
    case UPDATE_SUGG_ARTICLE_TYPE:
      return {
        ...state,
        suggestedArticleType: action.payload,
      };
    case UPDATE_RECOMMENDED_LINKS_ADP_DATA:
      return {
        ...state,
        recommendedLinksAdpData: {
          // ...state.recommendedLinksAdpData,
          ...action.payload,
        },
      };
    case RESET_ANALYTICS_STATES:
      return {
        ...state,
        suggestedArticles: [],
        suggestedArticleType: '',
      };
    default:
      return state;
  }
};
